module.exports = __webpack_public_path__ + "img/adhera_logo.e0f53806.svg";